type IconProps = React.ComponentProps<'svg'>

export function CheckIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3.25, 5.25)">
        <path
          d="M16.21967 0.21967c0.29289-0.29289 0.76765-0.29289 1.06055 0 0.29284 0.2929 0.29287 0.76767 0 1.06055l-11 11c-0.29287 0.29288-0.76765 0.29284-1.06055 0l-5-5c-0.29289-0.29289-0.29289-0.76765 0-1.06055 0.29289-0.29289 0.76765-0.29289 1.06055 0l4.46972 4.46973 10.46973-10.46973z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
